import { Component, OnInit, ChangeDetectionStrategy, Input, ViewEncapsulation, OnDestroy } from '@angular/core';
import { ToolEnum } from '../../models/tool.enum';
import { Select, Store } from '@ngxs/store';
import { EngineCameraState } from '../../state/camera/engine.camera.state';
import { Observable, Subject } from 'rxjs';
import { ZoomCamera, SetCamera, SetCameraMode } from '../../state/camera/engine.camera.actions';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { CenterCameraOnVisible } from '../../state/engine.actions';
import { ViewUI } from 'src/app/view/models/view-ui.enum';
import { RemoveContextLabel } from 'src/app/story/state/labels/story.labels.actions';
import { transition, trigger, sequence, style, animate } from '@angular/animations';
import { BreakpointState, BreakpointStateModel } from 'src/app/breakpoint/state/breakpoint.state';
import { Breakpoint } from 'src/app/breakpoint/models/breakpoint.enum';
import { NodeActions } from '../../state/nodes/engine.nodes.actions';
import { UndoState } from 'src/app/undo/state/undo.state';
import { UndoActions } from 'src/app/undo/state/undo.state.actions';
import { CameraService } from '../../camera.service';

@Component({
  selector: 'app-engine-camera-bar',
  templateUrl: './engine-camera-bar.component.html',
  styleUrls: ['./engine-camera-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('expand', [
      transition(':enter', [
        sequence([
          style({
            height: 0
          }),
          animate('150ms ease-in-out', style({ 
            height: '*'
          }))
        ])
      ]),
      transition(':leave', [
        sequence([
          animate('150ms ease-in-out', style({ 
            height: '0'
          }))
        ])
      ])
    ]),

    trigger('show', [
      transition(':enter', [
        sequence([
          style({ 
            height: '0'
          }),
          animate('125ms ease-in-out', style({ 
            height: '*'
          }))
        ])
      ]),
      transition(':leave', [
        sequence([
          animate('125ms 125ms ease-in-out', style({ 
            height: '0'
          }))
        ])
      ])
    ])
  ]
})
export class EngineCameraBarComponent implements OnInit, OnDestroy {
  // ---------- Selectors ----------
  @Select(EngineCameraState.getPanMode)
  panMode$: Observable<string>;

  @Select(BreakpointState.getBreakpoint)
  breakpoint$: Observable<Breakpoint>;



  // ---------- Input / Output ----------
  @Input()
  showNav = true;

  @Input()
  showZoom = true;

  @Input()
  showPan = true;

  @Input()
  showResetPosition = true;

  

  // ---------- Properties ----------
  viewLayout = ViewUI;
  toolEnum = ToolEnum;
  expandNav = false;
  breakpoint: Breakpoint;
  breakpointEnum = Breakpoint;
  padding: 'dense' | 'none' = 'none';
  ngUnsubscribe = new Subject();


  // ----------- Lifecycle ----------
  constructor(
    private store: Store,
    private cameraService: CameraService
  ) { }

  ngOnInit() {
    
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setZoom(state: 'in' | 'out' | '') {
    let zoomValue = (state === '') ? 0 : 8;
    zoomValue = (state === 'in') ? -zoomValue : zoomValue;
    
    this.store.dispatch(new ZoomCamera(zoomValue));
  }

  setZoomFixed(state: 'in' | 'out') {
    const zoomValue = (state === 'in') ? -8 : 8;
    this.cameraService.setCameraZoomWithVelocity(zoomValue);
  }

  returnToChapterCamera() {
    const chapter = this.store.selectSnapshot(StoryChaptersState.getSelectedChapter);
    this.store.dispatch(new SetCamera(chapter.camera.location));
  }

  resetChapter() {
    this.returnToChapterCamera();
  
    const chapterId = this.store.selectSnapshot(
      StoryChaptersState.getSelectedChapterId
    );
    this.store.dispatch(new UndoActions.UndoAll(chapterId));

    this.store.dispatch(
      new NodeActions.UpdateNodesChecked(false)
    );
    this.store.dispatch(new RemoveContextLabel());
  }

  centerCamera() {
    this.store.dispatch(new CenterCameraOnVisible());
  }

  togglePan() {
    const mode = this.store.selectSnapshot(EngineCameraState.getPanMode) === 'pan' ? 'rotate' : 'pan';
    this.store.dispatch(new SetCameraMode(mode));
  }

  toggleNav() {
    this.expandNav = !this.expandNav;
  }
}
